import React from "react";
import {
  GET_VISIBILITY,
  desiredOrderCVESeverity,
  cveBySeverityMap,
  FETCH_CVE_BY_SEVERITIES,
  FETCH_HIGHEST_CVE_SEVERITY,
  desiredOrderAlerts,
  sensitivityMap,
} from "./NetSpaceConstant";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Box, Grid, useMediaQuery } from "material-ui-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { StyledCardHeader } from "./NetSpaceUtils";
import { sensitivityColor } from "./NetSpaceUtils";
import { PieChart, Pie, Tooltip, Cell } from "recharts";
import { CustomCard } from "./NetSpaceCommonComp";
import { isNull } from "lodash";

function HighestCVESeverity() {
  const isSmall = useMediaQuery("(max-width:1600px)");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: FETCH_HIGHEST_CVE_SEVERITY,
    });
  }, []);
  const highestCVESeverity = useSelector(
    (state) => state.NetspaceReducer.highestCVESeverity,
  );
  const loader = useSelector(
    (state) =>
      state.NetspaceReducer.componentLoader[FETCH_HIGHEST_CVE_SEVERITY],
  );
  const totalHosts = highestCVESeverity
    ? Object.values(highestCVESeverity).reduce((acc, curr) => acc + curr, 0)
    : 0;
  const orderToUse =
    highestCVESeverity?.CRITICAL !== undefined &&
    !isNull(highestCVESeverity.CRITICAL)
      ? desiredOrderCVESeverity
      : desiredOrderAlerts;

  const renderContent = () => {
    if (highestCVESeverity) {
      let renderEachMonitor = [];
      let pieData = [];

      const mapToUse =
        highestCVESeverity?.CRITICAL !== undefined &&
        !isNull(highestCVESeverity?.CRITICAL)
          ? cveBySeverityMap
          : sensitivityMap;

      orderToUse.forEach((monitor) => {
        if (monitor in highestCVESeverity) {
          renderEachMonitor.push(
            <Grid item xs={12} key={`monitor-${monitor}`}>
              <div className={monitor}>
                {highestCVESeverity[monitor]} {mapToUse[monitor]}
              </div>
            </Grid>,
          );

          pieData.push({
            name: monitor,
            value: highestCVESeverity[monitor],
            color: sensitivityColor(monitor),
          });
        }
      });

      // ✅ If no valid data found
      if (renderEachMonitor.length === 0) {
        return <div>No Data Available</div>;
      }

      return (
        <a
          className="a-tag-none"
          href="https://nodezero.druvstar.net/investigate/hosts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Grid container direction="row" spacing={2}>
            <div className="netspace-common-container-class">
              <div className="netspace-value-container cveHost">
                {renderEachMonitor}
              </div>

              <Grid item xs={6}>
                <Box
                  sx={{
                    width: isSmall ? 120 : 150,
                    height: isSmall ? 100 : 120,
                  }}
                >
                  <PieChart
                    className="netspace-card-pie"
                    width={isSmall ? 130 : 150}
                    height={isSmall ? 100 : 120}
                  >
                    <Pie
                      isAnimationActive={false}
                      data={pieData}
                      nameKey="name"
                      dataKey="value"
                    >
                      {pieData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip wrapperClassName="custom-tooltip" />
                  </PieChart>
                </Box>
              </Grid>
            </div>
          </Grid>
        </a>
      );
    }

    // ✅ If highestCVESeverity itself is null/undefined
    return <div>No Data Available</div>;
  };

  return (
    <>
      <Grid item xs={2}>
        <CustomCard color="white">
          <StyledCardHeader
            title={ totalHosts > 0 ? `Risky Host by vulnerability: ${totalHosts}` : 'Risky Host by vulnerability'}
          />
          <CardContent className="card-content">
            {loader ? (
              <img src={Page_Loader} alt="loading" className="loader-img"></img>
            ) : (
              renderContent()
            )}
          </CardContent>
        </CustomCard>
      </Grid>
    </>
  );
}

export default HighestCVESeverity;
